import {ref, Ref} from "vue"
import UserInfoFormEnum from "@/config/UserInfoFormEnum"

const current_form: Ref<UserInfoFormEnum> = ref(UserInfoFormEnum.None)

export default current_form